import React, {useEffect, useState} from "react";
import enterpriseObjectClassFactory from "../../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../../eoec/eo/EnterpriseObject";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import EventBus from "../../util/EventBus";
import {Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import {DeleteForever} from "@mui/icons-material";
import CCButton from "../Common/CCButton";


export default function ProjectPlanPhaseMilestoneDelete(props: any) {
    const [projectPlanPhaseMilestoneEnterpriseObject] = useState(enterpriseObjectClassFactory("ProjectPlanPhaseMilestone") as EnterpriseObject);
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);

    function enterpriseComponentDeleteStartedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentDeleteCompletedListener(ec: EnterpriseComponent) {
        EventBus.components.emit("project-plan-phase-milestone-delete-save");
    }

    useEffect(() => {
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanPhaseMilestoneEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")!

        projectPlanPhaseMilestoneEnterpriseComponent.newQuery();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("USID", props.projectPlanPhaseMilestone.USID);
        projectPlanPhaseMilestoneEnterpriseComponent.setIDOCRequest("v1.ProjectPlanPhaseMilestone-001");
        projectPlanPhaseMilestoneEnterpriseComponent.setIDOCResponse("v1.ProjectPlanPhaseMilestone-001");
        projectPlanPhaseMilestoneEnterpriseComponent.executeQuery(1, 5);

        projectPlanPhaseMilestoneEnterpriseComponent.addDeleteStartedListener(enterpriseComponentDeleteStartedListener);
        projectPlanPhaseMilestoneEnterpriseComponent.addDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);

        return () => {
            projectPlanPhaseMilestoneEnterpriseComponent.removeDeleteStartedListener(enterpriseComponentDeleteStartedListener);
            projectPlanPhaseMilestoneEnterpriseComponent.removeDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);
        }

    }, [projectPlanPhaseMilestoneEnterpriseObject, props.projectPlanPhaseMilestone]);

    function onCancelHandler() {
        EventBus.components.emit("project-plan-phase-milestone-delete-cancel");
    }

    function deleteHandler() {
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanPhaseMilestoneEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")!
        projectPlanPhaseMilestoneEnterpriseComponent.executeDelete();

        EventBus.components.emit("project-plan-phase-milestone-delete-save");
    }

    function phaseMilestoneDeleteView() {
        let buttonHandler = null;
        let objectDetailContent = null;

        let firstButtonHandlerContent = (
            <CCButton
                className={css_buttons.redStandardButton}
                onClick={onCancelHandler}>
                Cancel
            </CCButton>
        );

        let secondButtonHandlerContent = (
            <CCButton
                className={css_buttons.blueStandardButton}
                animate={backgroundOperation}
                onClick={() => deleteHandler()}>
                Delete
            </CCButton>
        )

        buttonHandler = (
            <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                {firstButtonHandlerContent}
                {secondButtonHandlerContent}
            </DialogActions>
        );

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#000000"}}>Delete Milestone:&nbsp;&nbsp;</Typography>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#A8A9AF"}}>{props.projectPlanPhaseMilestone.Name}</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", margin: "20px 20px 20px 0"}}>
                                <div>
                                    <DeleteForever sx={{marginTop: "5px", width: "60px", height: "60px", color: "#BD2930"}}/>
                                </div>
                                <div>
                                    <Typography style={{margin: "0px 0 0 6px", fontSize: "16px", fontWeight: 400, color: "#BD2930"}}>Warning! This action will delete this milestone and any association to its references. It will not delete or alter any referenced documents. It cannot be undone!</Typography>
                                </div>

                            </div>
                        </div>
                        {objectDetailContent}
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }

    return (
        <>
            {phaseMilestoneDeleteView()}
        </>
    )
}
